/* eslint-disable @typescript-eslint/no-explicit-any */
export function showToast(message: string): void {
  window.$nuxt.$options.$notify.success(message);
}

export function showErrorToast(message: string): void {
  window.$nuxt.$options.$notify.error(message);
}

export function showInfoToast(message: string): void {
  window.$nuxt.$options.$notify.info(message);
}

export function showTransactionPendingToast(message: string): void {
  window.$nuxt.$options.$notify.addTransactionPending(message);
}
